export default __webpack_public_path__ + "static/media/banner.574bb221.webp";